import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromForgotPasscodeResendOtp from '../reducers/forgot-passcode-resend-otp.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region VALIDATE GOV ID AND PASSPORT NUMBER SUB STATE
export const getForgotPasscodeResendOtpState = createSelector(
  getAuthState,
  state => state[fromForgotPasscodeResendOtp.forgotPasscodeResendOtpFeatureKey]
);

export const getForgotPasscodeResendOtpIsLoading = createSelector(
  getForgotPasscodeResendOtpState,
  fromForgotPasscodeResendOtp.getForgotPasscodeResendOtpIsLoading
);

export const getForgotPasscodeResendOtpRequest = createSelector(
  getForgotPasscodeResendOtpState,
  fromForgotPasscodeResendOtp.getForgotPasscodeResendOtpRequest
);

export const getForgotPasscodeResendOtpResponse = createSelector(
  getForgotPasscodeResendOtpState,
  fromForgotPasscodeResendOtp.getForgotPasscodeResendOtpResponse
);

export const getForgotPasscodeResendOtpFailure = createSelector(
  getForgotPasscodeResendOtpState,
  fromForgotPasscodeResendOtp.getForgotPasscodeResendOtpFailure
);
